/*
 * Created with JetBrains WebStorm.
 * User: mslobozeanu
 * Date: 15/04/2015
 */

/** @namespace TS */
/** @namespace TS.model */

/**
 *  A Knockout [observable]{@link http://knockoutjs.com/documentation/observables.html} object.
 * @typedef Observable
 * */

TS.ns('TS.domain');

(function () {
    'use strict';

    /**
     * @class TS.domain.CommandContainer
     * @ignore
     */
    TS.domain.CommandContainer = new Class({
        Extends: TS.Observable,

        initialize: function (config, owner) {
            var me = this;

            me[TS.Constants.ownerProp] = owner;
            if (config && config.Commands && $.isArray(config.Commands)) {
                me.Commands = ko.observableArray(ko.utils.arrayMap(config.Commands, me._createCommand.bind(me)));
            } else {
                me.Commands = ko.observableArray();
            }
            me.parent(config, owner);
        },

        _getOwner: function () {
            return this[TS.Constants.ownerProp];
        },

        _createCommand: function (config) {
            var me = this,
                owner = me._getOwner(),
                cmd = new TS.domain.Command(config, owner);
            if (me.categoryCode)
                cmd.categoryCode = me.categoryCode + '.' + me.Code;
            else
                cmd.categoryCode = me.Code;
            cmd.autoCreated = true;
            return cmd;
        },

        /**
         * Returns the command with the specified code
         * @param code
         * @returns {TS.viewModel.Command} The command or <code>null</code> if no command with specified code has been found.
         */
        getCommand: function (code) {
            var me = this,
                childCode,
                result = null;

            if (code.indexOf('.') > -1) {
                var parts = code.split('.');
                code = parts[0];
                childCode = parts.slice(1).join('.');
            }

            $.each(me.Commands(), function (index, item) {
                if (item.Code === code) {
                    result = item;
                    return false;
                }
            });
            if (result && childCode) {
                return result.getCommand(childCode);
            }
            return result;
        },

        getCommandIndex: function (code) {
            var me = this,
                result = -1;

            $.each(me.Commands(), function (index, item) {
                if (item.Code == code) {
                    result = index;
                    return false; //break loop
                }
            });
            return result;
        },

        hasCommand: function (code) {
            return this.getCommandIndex(code) !== -1;
        },

        _setData: function (config) {
            var me = this,
                commands = config.Commands;

            if(commands) {
                // remove
                $.each(me.Commands.slice(), function (idx, cmd) {
                    var index = TS.Util.findIndex(commands, cmd.Code, 'Code');
                    if (index == -1 && cmd.autoCreated === true) {
                        me.Commands.splice(index, 1);
                    }
                });

                // add or update
                $.each(commands, function (idx, cmd) {
                    var index;
                    index = TS.Util.findIndex(me.Commands(), cmd.Code, 'Code');
                    if (index == -1 && cmd.autoCreated === true) {
                        me.Commands.splice(index, 0, me._createCommand(cmd));
                    } else {
                        me.Commands()[index]._setData(cmd);
                    }
                });
            }else{
                me.Commands.splice(0);
            }
        }
    });
})();